import { axios } from "../utils/request";

// 1.2.1.1 获取账户余额
export function accountBalances(data) {
  return axios({
    url: '/h5Index/accountBalances',
    method: 'post',
    data
  })
}


// 1.2.1.2 获取收益
export function profit(data) {
  return axios({
    url: '/h5Index/profit',
    method: 'post',
    data
  })
}

// 1.2.1.3 获取营业额
export function turnover(data) {
  return axios({
    url: '/h5Index/turnover',
    method: 'post',
    data
  })
}

// 1.2.1.2 获取订单数
export function orderCount(data) {
  return axios({
    url: '/h5Index/orderCount',
    method: 'post',
    data
  })
}
